import type { RouteObject } from 'react-router-dom';

/**
 * «Stock de folios»: the per (company, type) policy and the lifecycle of the
 * requests to the SII (A-06 of the frontend roadmap).
 *
 * Lazy-loaded like `AppLayout`'s other 32 — see the note in `router.tsx`.
 */
export const foliosRoutes: RouteObject[] = [
  {
    path: 'folios',
    lazy: () =>
      import('@/routes/pages/FoliosPage').then((m) => ({
        Component: m.FoliosPage,
      })),
  },
];
